import React from 'react';

const LoadingSpinner = ({ text, paddingTop = false }) => {
  return (
    <div className={`loading-indicator-wrapper ${paddingTop ? 'paddingTop' : ''}`}>
      <div className='loading-indicator' />
      {text !== null && <span className='loading-indicator-text'>{text || 'Loading...'}</span>}
    </div>
  );
};

export default LoadingSpinner;
